import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface LoadingOverlayProps {
  /** Vertical padding (default: 4) */
  py?: number;
  /** Size of the spinner (default: undefined for standard size) */
  size?: number;
  /** Minimum height for the container */
  minHeight?: number;
}

/**
 * Centered loading spinner. Use when a section or full view is loading.
 */
export default function LoadingOverlay({ py = 4, size, minHeight }: LoadingOverlayProps) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" py={py} minHeight={minHeight}>
      <CircularProgress size={size} />
    </Box>
  );
}
